/* eslint-disable */
export class VehicleCapacity {

    capacityId: number | undefined;
    name: string | undefined;
    weight: number | undefined;
    weightUnit: any | undefined;
    length: number | undefined;
    breadth: number | undefined;
    height: number | undefined;
    maxQty: number | undefined;
    typeId: number | undefined;
    measureUnit: any | undefined;
    baseUOM: any | undefined;
    
}